/* Results screen shown after YouTube channel import completes. */

import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

interface YouTubeImportResultsProps {
  imported: number;
  failed: number;
  onDone: () => void;
}

export function YouTubeImportResults({
  imported,
  failed,
  onDone,
}: YouTubeImportResultsProps) {
  return (
    <div className="flex flex-col items-center gap-4 py-4">
      <CheckCircle2 className="size-10 text-primary" />

      <div className="text-center space-y-1">
        <p className="text-sm font-medium">
          {imported} channel{imported !== 1 ? "s" : ""} imported
        </p>
        {failed > 0 && (
          <p className="text-xs text-muted-foreground">
            {failed} channel{failed !== 1 ? "s" : ""} skipped (already exist or
            failed)
          </p>
        )}
      </div>

      <Button onClick={onDone} className="w-full">
        Done
      </Button>
    </div>
  );
}
